module.exports = __webpack_public_path__ + "img/cd780b0.jpg";